import React from 'react';
import { Accordion, Col, Container, Form, Row } from 'react-bootstrap';

import StepHeader from "../../../components/v2/StepHeader"
import DepartmentHeader from "../../../components/v2/DepartmentHeader";


function CompletedCheckBox(props) {
    return (
        <Form.Check
            type="checkbox"
            onChange={props.onChange}
            id={'program-' + props.programId + '_step-' + props.step}
            name={'program-' + props.programId + '_step-' + props.step}
            aria-label={props.ariaLabel}
            label={props.label}
            value={props.completed}
            defaultChecked={props.defaultChecked}
            disabled={props.disabled}
            />
    )
}

export default function AssessmentStep3(props) {

    const incompleteStepsExist = (programId) => {
        // This step cannot be completed if previous steps were not.
        if (!props.step2CompletionData[programId] ||
            !props.step2CompletionData[programId].completed) {
            return true
        }
        if (!props.step1CompletionData[programId] ||
            !props.step1CompletionData[programId].completed) {
            return true
        }
        
        return false
    }

    const isFormDisabled = (programId) => {
        if (incompleteStepsExist(programId)) {
            return true
        }
        
        if (programId) {
            // If Step 4 was completed, we shouldn't allow
            // edit of this step if next step is complete
            if ((programId in props.step4CompletionData) &&
                props.step4CompletionData[programId]?.completed) {
                return true
            }
        }
        
        return false
    }

    const prefix = 'program-'
    let allPrograms = props.department.submittedPrograms
    let filteredPrograms = []
    
    if (filteredPrograms.length == 0) {
        filteredPrograms = allPrograms.filter(function(obj) {
            return (props.activePrograms[obj.programId] == 'yes')
        })
    }
    
    let themeName = props.theme.name
    let availableLearningOutcomes = {}

    props.department.submittedPrograms.map(program => {
        let programMappedSlos = props.mappedSlos[program.programId]
        if (!(program.programId in availableLearningOutcomes)) {
            availableLearningOutcomes[program.programId] = []
        }

        if (program.programId in props.learningOutcomes) {
            props.learningOutcomes[program.programId].map(slo => {
                if (slo.sloId in programMappedSlos) {
                    let mappedSlo = programMappedSlos[slo.sloId]
                    if (mappedSlo.firstTheme === themeName && mappedSlo.firstThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.secondTheme === themeName && mappedSlo.secondThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.thirdTheme === themeName && mappedSlo.thirdThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    }
                }
            })
        }
        
    })

    // defaultTabs is provided to Accordion to expand all accordion items by default.
    //let defaultTabs = Array.from(props.department.submittedPrograms, (p,k) => 'program-' + k)
    let defaultTabs = []
    props.department.submittedPrograms.forEach((p) => {
        if (!(p.programId in props.step3CompletionData && props.step3CompletionData[p.programId].completed)) {
            defaultTabs.push(prefix + p.programId)
        }
    })
    return (
        <React.Fragment>
            <StepHeader text={props.stepTitle} />
            <div className="p-5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    Check the boxes below once assessment has been conducted for 
                    each program (degree, certificate and gen ed area) using the tools 
                    that were developed/adapted in the previous step. Before completing 
                    this step, please review background information about conducting 
                    assessment, including how to collect data from across different 
                    courses/course sections: <a href="https://rise.articulate.com/share/7YF8KpdTpmenGRyD2mfOvBKnc6i-An7H#/lessons/4znW_TMqkG8TX0ZCyJiSSz0s92R3dThj" target="_blank" rel="noopener noreferrer">View</a>
                </div>

                <DepartmentHeader department={props.department} />

                <div className="pb-md4 mx-auto">
                    <Accordion defaultActiveKey={defaultTabs} alwaysOpen>
                    {
                        filteredPrograms?.map((program,key) =>
                            <Accordion.Item eventKey={prefix + program.programId} key={program.programId}>
                                <Accordion.Header>
                                    {program.name} {(program.programId in props.step3CompletionData && props.step3CompletionData[program.programId].completed) ? ' - Completed' : ''}
                                </Accordion.Header>
                                <Accordion.Body>
                                    {
                                        <Container fluid>
                                            <Row>
                                                <Col 
                                                    md={{span: 8, offset: 3}}
                                                    lg={{span: 12, offset: 2}}
                                                    >
                                                    <CompletedCheckBox
                                                        onChange={props.onStepCompleted}
                                                        programId={program.programId}
                                                        completed={props.step3CompletionData[program.programId]?.completed}
                                                        defaultChecked={props.step3CompletionData[program.programId]?.completed}
                                                        ariaLabel="Was assessment tool used to conduct assessment?"
                                                        label="The assessment tool has been used to conduct assessment and collect data in this program."
                                                        step="3"
                                                        disabled={isFormDisabled(program.programId)}
                                                        />
                                                    { incompleteStepsExist(program.programId) 
                                                        ? <div className="p-3">
                                                            <span className="text-danger">
                                                                Previous step(s) must be completed before this step can be completed.
                                                            </span>
                                                          </div>
                                                        : <></>
                                                    }
                                                </Col>
                                            </Row>
                                        </Container>
                                    }
                                </Accordion.Body>
                            </Accordion.Item>
                        )
                    }
                    </Accordion>
                </div>
            </div>
        </React.Fragment>
    )
}
